module.exports = __webpack_public_path__ + "img/cases-brand-avic-lazyload-1317.02b06499.jpg";